import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ProductAction, SiteAction } from '../../actions';
import { InputBasicSelect } from "../../components/common/Inputs";
import { history } from '../../history';
import { Translate as t } from '../../config/Translate';

const AdminProductUpdateSite = ({ product, UpdateProductSite, ClearUpdateResult, isUpdateRes }) => {

	const [siteCombo, setSiteCombo] = useState([]);
	const [siteId, setSiteId] = useState(product.siteId || "");
	const [errMsg, setErrMsg] = useState("");

	// 현재 site 가 콤보(= caller 가 볼 수 있는 범위) 밖인지. 서버도 같은 기준으로 저장을
	//   막으므로(403), 그 상태에서 이름 재동기화를 시도하면 오류만 뜬다.
	//   기준은 caller 가 볼 수 있는 범위이지 장비의 조직이 아니다(§2.1/§2.3).
	const [currentOutOfScope, setCurrentOutOfScope] = useState(false);
	// 판정 전에는 시도하지 않는다 — 초기값이 '허용' 이면 로딩 중 클릭이 403 을 유발한다.
	const [comboReady, setComboReady] = useState(false);

	// 사이트 목록은 **caller 스코프**다 — 장비의 조직과 무관하다
	// (docs/specs/site-domain-model.md §2.1/§2.3).
	useEffect(() => {
		GetSitesCombo();
	}, []);
	useEffect(() => {
		if (isUpdateRes) {
			ClearUpdateResult();
			history.push("/Admin/AdminProductInfo/" + product._id + "/info");
		}
	}, [isUpdateRes]);


	// BUG-214: 콤보는 서버 스코프(site.getcombo → getPermSimple)로 걸러져 오므로, **현재 연결된
	//   site 가 목록에 없을 수 있다.** 실측상 companyId 가 빈 site 가 801건이고 그런 site 는
	//   어떤 회사 스코프에도 안 잡힌다(RA325A5214 의 'Dr. Tallani Dental Clinic' 이 그 경우).
	//
	//   목록에 없으면 <select value={siteId}> 가 매칭에 실패해 브라우저가 **첫 항목(해제)** 을
	//   선택된 것처럼 표시한다. 그 결과 두 가지가 동시에 깨진다.
	//     ① 현재 연결 상태를 잘못 보여준다 (붙어 있는데 "해제"로 보인다)
	//     ② 해제를 눌러도 DOM value 가 이미 "" 라 change 이벤트가 발생하지 않는다
	//        → siteId state 가 그대로라 "변경 사항 없음" 으로 막혀 **해제조차 불가능**하다
	//
	//   현재 값을 항상 선택지로 넣어 두 문제를 함께 없앤다(라벨은 currentSiteLabel 참고).
	// BUG-214: 현재 연결된 site 를 선택지로 주입할 때 쓰는 라벨.
	//   ⚠️ 원시 siteId(ObjectId)를 라벨로 쓰지 않는다. `sitename` 이 비어 있는 상황이
	//   곧 BUG-214 그 자체라, 폴백으로 두면 **문제가 있는 장비에서 100% ID 가 노출된다**
	//   (다른 항목은 병원 이름인데 현재 값만 6a798a93... 으로 보인다).
	//   이름을 못 구하면 사용자에게 의미 없는 식별자 대신 N/A 로 표시한다.
	const currentSiteLabel = () => product.site?.sitename || product.sitename || t('common.label.na');

	const GetSitesCombo = () => {
		const list = [{ code: "", title: t('product.updateSite.removeInstallation') }];
		SiteAction.GetSiteCombo().then((data) => {
			const rows = Array.isArray(data) ? data : [];
			const needsCurrent = !!product.siteId && !rows.some((x) => x?.code === product.siteId);
			const current = needsCurrent
				? [{ code: product.siteId, title: currentSiteLabel() }]
				: [];
			setCurrentOutOfScope(needsCurrent);
			setSiteCombo(list.concat(current, rows));
			setComboReady(true);
		});
	}

	const handleChangeData = (e) => {
		setErrMsg("");
		setSiteId(e.target.value);
	}

	// 사이트는 붙어 있는데 sitename 만 비어 있는 장비가 실제로 존재한다. 그 경우 콤보의
	//   기본 선택값이 곧 현재 사이트라, siteId 동일 비교만 하면 "변경 사항 없음" 으로 막혀
	//   서버 요청이 나가지 않는다 — 이름을 채우려면 사이트를 다른 값으로 바꿨다 되돌려야
	//   하는 모순이 생긴다. 같은 siteId 라도 이름이 비면 재동기화를 허용한다.
	const Update = () => {
		// 이름이 비어 있으면 같은 site 로도 재동기화한다 — 서버가 siteId 로 이름을 채운다.
		// 콤보 밖 site 에는 재동기화를 시도하지 않는다 — 서버가 403 으로 막는다.
		const needsSitenameSync = comboReady && !currentOutOfScope
			&& !!siteId && siteId === (product.siteId || "") && !product.sitename;

		if (product.siteId != siteId || needsSitenameSync) {
			// 사이트 이름은 서버가 siteId 로 조회해 채운다. 클라이언트에서 전달하지 않는다.
			UpdateProductSite(product._id, product.siteId || "", siteId);
		} else {
			setErrMsg(t('common.message.info.noChanges'));
		}
	}

	const option = {
		label: t('product.updateSite.targetSite'),
		name: "siteId",
		val: siteId,
		list: siteCombo
	}

	return (
		<>
			<div className="card bg-info text-white">
				<div className="card-header">
					<div className="card-title">{t('product.updateSite.title')}</div>
				</div>
				<div className="card-body">
					<h4>{t('product.updateSite.appliedImmediately')}</h4>
					<p>{t('product.updateSite.irreversibleWarning')}</p>
					<p>{t('product.updateSite.confirmChange')}</p>
					<div style={{ "marginLeft": "-15px" }}>
						<InputBasicSelect
							options={option}
							isForm={true}
							editable={true}
							onchange={handleChangeData} />
					</div>
					{errMsg && <span className="alert alert-info">{errMsg}</span>}
				</div>
			</div>
			<button className="btn btn-outline-danger" onClick={() => Update()}>Update SIte</button>
		</>
	);
};

const mapState = (state) => {
	const isUpdateRes = state.ProductReducer.isUpdateRes;
	return { isUpdateRes };
}

const mapDispatch = dispatch => ({
	ClearUpdateResult: () => dispatch(ProductAction.ClearUpdateResult()),
	UpdateProductSite: (_id, nowSiteId, newSiteId) => dispatch(ProductAction.UpdateProductSite(_id, nowSiteId, newSiteId))
})

export default connect(mapState, mapDispatch)(AdminProductUpdateSite);